<div class="form-group" [ngClass]="additionalGroupClass" [class.opacity-75]="disabled">
    @if (label) {
        <label class="d-block" [class.mb-1]="!hint" [class.mb-0]="hint" [attr.for]="id"
            >{{ label }}
            @if (isRequiredField) {
                <sup>*</sup>
            }
        </label>
    }

    @if (hint) {
        <div class="hint mb-1" [innerHTML]="hint"></div>
    }

    <textarea
        class="form-control"
        [attr.id]="id"
        [disabled]="disabled ? disabled : null"
        [attr.placeholder]="placeholder"
        [class.is-invalid]="inputControl?.touched && !inputControl?.pristine && inputControl?.invalid"
        [class.is-valid]="hasBlur && inputControl?.valid"
        (keydown.enter)="handlePressEnter($event)"
        (blur)="hasBlur = true"
        (change)="changeValue($event)"
        (keyup)="changeValue($event)"
        >{{ value }}</textarea
    >

    @if (inputControl?.errors && inputControl?.touched && hasBlur && showErrorMessage) {
        <div class="invalid-feedback">
            <span class="invalid-feedback-box">{{ inputControl.errors | validationMessage }}</span>
        </div>
    }
</div>
